import game176 from "./176.png";
import game187 from "./187.png";
import game188 from "./188.png";
import game189 from "./189.png";
import game200 from "./200.png";
import game203 from "./203.png";
import game205 from "./205.png";
import game210 from "./210.png";
import game211 from "./211.png";
import game180 from "./180.png";
import game170 from "./170.png";
import game150 from "./150.png";
import game149 from "./149.png";
import game178 from "./178.png";
import game158 from "./158.png";
import game165 from "./165.png";
import game159 from "./159.png";
import game160 from "./160.png";
import game157 from "./157.png";
import game153 from "./153.png";
import game167 from "./167.png";
import game156 from "./156.png";
import game155 from "./155.png";
import game163 from "./163.png";
import game152 from "./152.png";
import game151 from "./151.png";
import game175 from "./175.png";
import game162 from "./162.png";
import game161 from "./161.png";
import game154 from "./154.png";
import game183 from "./183.png";
import game184 from "./184.png";
import game186 from "./186.png";
import game185 from "./185.png";

export default [
  { type: "tomhorn", img: game176, id: 176, name: "243 Crystal Fruits" },
  { type: "tomhorn", img: game200, id: 200, name: "The Secret Of BA" },
  { type: "tomhorn", img: game160, id: 160, name: "Book Of Spells" },
  { type: "tomhorn", img: game205, id: 205, name: "243 Crystal Fruits Reversed" },
  { type: "tomhorn", img: game170, id: 170, name: "Fire'n'Hot" },
  { type: "tomhorn", img: game149, id: 149, name: "Dragon Egg" },
  { type: "tomhorn", img: game187, id: 187, name: "Hot'n'Fruity" },
  { type: "tomhorn", img: game184, id: 184, name: "Sherlock. A Scandal in Bohemia" },
  { type: "tomhorn", img: game154, id: 154, name: "Flaming Fruit" },
  { type: "tomhorn", img: game203, id: 203, name: "Joker Reelz" },
  { type: "tomhorn", img: game210, id: 210, name: "Wolf Sierra" },
  { type: "tomhorn", img: game161, id: 161, name: "Monkey 27" },
  { type: "tomhorn", img: game162, id: 162, name: "Don Juan's Peppers" },
  { type: "tomhorn", img: game211, id: 211, name: "Gold X" },
  { type: "tomhorn", img: game185, id: 185, name: "Kongo Bongo" },
  { type: "tomhorn", img: game159, id: 159, name: "Blackbeard's Quest" },
  { type: "tomhorn", img: game186, id: 186, name: "Inca's Treasure" },
  { type: "tomhorn", img: game153, id: 153, name: "The Cup" },
  { type: "tomhorn", img: game163, id: 163, name: "Thrones Of Persia" },
  { type: "tomhorn", img: game175, id: 175, name: "Pandas Run" },
  { type: "tomhorn", img: game156, id: 156, name: "Black Mummy" },
  { type: "tomhorn", img: game188, id: 188, name: "Diamond Hill" },
  { type: "tomhorn", img: game158, id: 158, name: "Hot Blizzard" },
  { type: "tomhorn", img: game183, id: 183, name: "Frozen Queen" },
  { type: "tomhorn", img: game165, id: 165, name: "Geisha's Fan" },
  { type: "tomhorn", img: game189, id: 189, name: "Spinball " },
  { type: "tomhorn", img: game180, id: 180, name: "Dragon Riches" },
  { type: "tomhorn", img: game150, id: 150, name: "Feng Fu" },
  { type: "tomhorn", img: game178, id: 178, name: "Monster Madness" },
  { type: "tomhorn", img: game157, id: 157, name: "Sizable Win" },
  { type: "tomhorn", img: game167, id: 167, name: "Shaolin's Tiger" },
  { type: "tomhorn", img: game155, id: 155, name: "Triple Joker" },
  { type: "tomhorn", img: game152, id: 152, name: "Sky Barons" },
  { type: "tomhorn", img: game151, id: 151, name: "Savannah King" },
]


// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/tomhorn/assets/index.js